import styled from 'styled-components';

const resetButton = `
  margin: 0;
  border: none;
  background: none;
  font-family: inherit;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    border-radius: var(--radius-control);
    box-shadow: 0 0 0 3px var(--color-accent-soft);
  }
`;

const MenuToggleButton = styled.button`
  ${resetButton}
  padding: 15px 15px 0;
  color: var(--color-header-icon);
  line-height: 1;

  i {
    font-size: 26px;
  }
`;

const UserMenuButton = styled.button`
  ${resetButton}
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  color: var(--color-text-body);
`;

const UserMenu = styled.div`
  min-width: 15rem;
`;

const UserSummary = styled.div`
  padding: 0.75rem 1.25rem;
  line-height: 1.4;
`;

const HeaderStyled = { MenuToggleButton, UserMenuButton, UserMenu, UserSummary };

export default HeaderStyled;
